"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabControl = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../../mantine-hooks/src");
var theme_1 = require("../../../../mantine-theme/src");
var TabControl_styles_1 = __importDefault(require("./TabControl.styles"));
function TabControl(_a) {
    var _b;
    var themeOverride = _a.themeOverride, active = _a.active, elementRef = _a.elementRef, tabProps = _a.tabProps, color = _a.color, others = __rest(_a, ["themeOverride", "active", "elementRef", "tabProps", "color"]);
    var label = tabProps.label, icon = tabProps.icon, overrideColor = tabProps.color, _ = tabProps.elementRef, props = __rest(tabProps, ["label", "icon", "color", "elementRef"]);
    var classes = TabControl_styles_1.default({
        reduceMotion: hooks_1.useReducedMotion(),
        color: overrideColor || color,
        theme: theme_1.useMantineTheme(themeOverride),
    });
    return (react_1.default.createElement("button", __assign({}, others, props, { "data-mantine-tab": true, "data-mantine-composable": true, tabIndex: active ? 0 : -1, className: clsx_1.default(classes.tab, (_b = {}, _b[classes.tabActive] = active, _b)), type: "button", role: "tab", "aria-selected": active, ref: hooks_1.useMergedRef(elementRef, tabProps.elementRef) }),
        react_1.default.createElement("div", { className: classes.tabInner },
            icon && (react_1.default.createElement("div", { "data-mantine-icon": true, className: classes.tabIcon }, icon)),
            label && react_1.default.createElement("div", { "data-mantine-label": true }, label))));
}
exports.TabControl = TabControl;
TabControl.displayName = '@mantine/core/TabControl';
